import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Button, Input, Table, Form, InputNumber, Typography, Popconfirm, Modal, Empty } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { getStyle, getBizID, getServices, getObjectiveCheck } from '../../libs/todoSlice'
import {
  getHistoryDetail,
  setMemberOneFailRedux,
  setMemberSuccessRedux,
  setMemberFailRedux,
  setHistoryDetail,
  setHistorySuccess,
  setHistoryFail,
  getHistoryFailDataRedux,
  setHistoryFailDataRedux,
  setHistoryFailDataLoadingWithIndexRedux,
  setHistoryFailDataTitleTHWithIndexRedux,
  setHistoryFailDataTitleENWithIndexRedux,
} from "../../libs/historySlice";
import LoadingComponent from "../../lib/LoadingComponent";
import fontColor from "../../lib/fontColor";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from "axios";
import { retryPreRegisterItems } from "../../lib/callAgainPreRegister";
import { resolveNoteText } from "../../lib/errorKeyNote";
import { buildCAPayload, buildCAFailResponse, CA_FAILURE_MESSAGE } from "../../lib/caPayload";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            // {
            //   required: true,
            //   message: `Please Input ${title}!`,
            // },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// key ของแถวที่เสถียร: ใช้ request.key (uuid ที่ AddMember ใส่ไว้) ถ้ามี ไม่งั้น fallback เป็น idx-N
const rowKey = (items, index) => items?.request?.key ?? `idx-${index}`

const HistoryDetailFail = () => {
  const dispatch = useDispatch();
  const details = useSelector(getHistoryDetail);
  const services = useSelector(getServices);
  const objectiveCheck = useSelector(getObjectiveCheck);
  const setDetails = (action) => {
    dispatch(
      setHistoryDetail({
        historydetail: action,
      }),
    );
  };
  const style = useSelector(getStyle);
  const business_id = useSelector(getBizID);
  const [form] = Form.useForm();

  const [modalNote, setModalNote] = useState(false);
  const [objective, setObjective] = useState([]);

  const data = useSelector(getHistoryFailDataRedux);
  const setData = (action) => {
    dispatch(
      setHistoryFailDataRedux({
        historyFailData: action,
      }),
    );
  };
  const setMemberOneFail = (action) => {
    dispatch(
      setMemberOneFailRedux({
        memberOneFail: action,
      }),
    );
  };

  const setMemberSuccess = (action) => {
    dispatch(
      setMemberSuccessRedux({
        memberSuccess: action,
      }),
    );
  };
  const setMemberFail = (action) => {
    dispatch(
      setMemberFailRedux({
        member_fail: action,
      }),
    );
  };

  const [fileID, setFileID] = useState("");
  const [total, setTotal] = useState("");
  const [loading, setLoading] = useState(false);
  const [noteTXT, setNoteTXT] = useState([]);

  const prepareData = () => {
    setObjective(
      details.importHistories[details.importHistories.length - 1].objective,
    );
    // setObjective(details.importHistories[details.importHistories.length - 1].objectiveCheck)

    setData(
      details.importHistories[
        details.importHistories.length - 1
      ].failDetail.map((items, index) => {
        return {
          key: rowKey(items, index),
          index: index,
          loading: false,
          // index: items.request.index,
          request: items.request,
          contract_no: items.request
            ? (items.request.contract_no ?? "-")
            : (items.contract_no ?? "-"),
          title_th: items.request
            ? (items.request.title_th ?? null)
            : (items.title_th ?? null),
          title_special_th: items.request
            ? (items.request.title_special_th ?? null)
            : (items.title_special_th ?? null),
          employee_id: items.request
            ? (items.request.employee_id ?? null)
            : (items.employee_id ?? null),
          name_th: items.request
            ? (items.request.name_th ?? null)
            : (items.name_th ?? null),
          surname_th: items.request
            ? (items.request.surname_th ?? null)
            : (items.surname_th ?? null),
          name_eng: items.request
            ? (items.request.name_eng ?? null)
            : (items.name_eng ?? null),
          surname_eng: items.request
            ? (items.request.surname_eng ?? null)
            : (items.surname_eng ?? null),
          cid: items.request
            ? (items.request.cid ?? null)
            : (items.cid ?? null),
          address: items.request
            ? (items.request.address ?? null)
            : (items.address ?? null),
          tel: items.request
            ? (items.request.tel ?? null)
            : (items.tel ?? null),
          mobile: items.request
            ? (items.request.mobile ?? null)
            : (items.mobile ?? null),
          email: items.request
            ? (items.request.email ?? null)
            : (items.email ?? null),
          biz_email: items.request
            ? (items.request.biz_email ?? null)
            : (items.biz_email ?? null),
          position: items.request
            ? (items.request.position ?? null)
            : (items.position ?? null),
          sub_organization: items.request
            ? (items.request.sub_organization ?? null)
            : (items.sub_organization ?? null),
          organization: items.request
            ? (items.request.organization ?? null)
            : (items.organization ?? null),
          tax_id: items.request
            ? (items.request.tax_id ?? null)
            : (items.tax_id ?? null),
          maintainer_name_1: items.request
            ? (items.request.maintainer_name_1 ?? null)
            : (items.maintainer_name_1 ?? null),
          maintainer_surname_1: items.request
            ? (items.request.maintainer_surname_1 ?? null)
            : (items.maintainer_surname_1 ?? null),
          maintainer_name_2: items.request
            ? (items.request.maintainer_name_2 ?? null)
            : (items.maintainer_name_2 ?? null),
          maintainer_surname_2: items.request
            ? (items.request.maintainer_surname_2 ?? null)
            : (items.maintainer_surname_2 ?? null),
          maintainer_name_3: items.request
            ? (items.request.maintainer_name_3 ?? null)
            : (items.maintainer_name_3 ?? null),
          maintainer_surname_3: items.request
            ? (items.request.maintainer_surname_3 ?? null)
            : (items.maintainer_surname_3 ?? null),
          maintainer_name_4: items.request
            ? (items.request.maintainer_name_4 ?? null)
            : (items.maintainer_name_4 ?? null),
          maintainer_surname_4: items.request
            ? (items.request.maintainer_surname_4 ?? null)
            : (items.maintainer_surname_4 ?? null),
          maintainer_email_1: items.request
            ? (items.request.maintainer_email_1 ?? null)
            : (items.maintainer_email_1 ?? null),
          maintainer_email_2: items.request
            ? (items.request.maintainer_email_2 ?? null)
            : (items.maintainer_email_2 ?? null),
          maintainer_email_3: items.request
            ? (items.request.maintainer_email_3 ?? null)
            : (items.maintainer_email_3 ?? null),
          maintainer_email_4: items.request
            ? (items.request.maintainer_email_4 ?? null)
            : (items.maintainer_email_4 ?? null),
          maintainer_tel_1: items.request
            ? (items.request.maintainer_tel_1 ?? null)
            : (items.maintainer_tel_1 ?? null),
          maintainer_tel_2: items.request
            ? (items.request.maintainer_tel_2 ?? null)
            : (items.maintainer_tel_2 ?? null),
          maintainer_tel_3: items.request
            ? (items.request.maintainer_tel_3 ?? null)
            : (items.maintainer_tel_3 ?? null),
          maintainer_tel_4: items.request
            ? (items.request.maintainer_tel_4 ?? null)
            : (items.maintainer_tel_4 ?? null),
          id_card_type: items.request
            ? (items.request.id_card_type ?? null)
            : (items.id_card_type ?? null),
          room_no: items.request
            ? (items.request.room_no ?? null)
            : (items.room_no ?? null),
          house_no: items.request
            ? (items.request.house_no ?? null)
            : (items.house_no ?? null),
          moo: items.request
            ? (items.request.moo ?? null)
            : (items.moo ?? null),
          floor: items.request
            ? (items.request.floor ?? null)
            : (items.floor ?? null),
          street: items.request
            ? (items.request.street ?? null)
            : (items.street ?? null),
          building_name: items.request
            ? (items.request.building_name ?? null)
            : (items.building_name ?? null),
          alley: items.request
            ? (items.request.alley ?? null)
            : (items.alley ?? null),
          start_year: items.request
            ? (items.request.start_year ?? null)
            : (items.start_year ?? null),
          end_year: items.request
            ? (items.request.end_year ?? null)
            : (items.end_year ?? null),
          middle_name_th: items.request
            ? (items.request.middle_name_th ?? null)
            : (items.middle_name_th ?? null),
          middle_name_eng: items.request
            ? (items.request.middle_name_eng ?? null)
            : (items.middle_name_eng ?? null),
          special_title_th: items.request
            ? (items.request.special_title_th ?? null)
            : (items.special_title_th ?? null),
          special_title_eng: items.request
            ? (items.request.special_title_eng ?? null)
            : (items.special_title_eng ?? null),
          degree: items.request
            ? (items.request.degree ?? null)
            : (items.degree ?? null),
          faculty: items.request
            ? (items.request.faculty ?? null)
            : (items.faculty ?? null),
          major: items.request
            ? (items.request.major ?? null)
            : (items.major ?? null),
          minor: items.request
            ? (items.request.minor ?? null)
            : (items.minor ?? null),
          status: items.request
            ? (items.request.status ?? null)
            : (items.status ?? null),
          sub_district: items.request
            ? (items.request.sub_district ?? null)
            : (items.sub_district ?? null),
          district: items.request
            ? (items.request.district ?? null)
            : (items.district ?? null),
          province: items.request
            ? (items.request.province ?? null)
            : (items.province ?? null),
          zipcode: items.request
            ? (items.request.zipcode ?? null)
            : (items.zipcode ?? null),
          student_id: items.request
            ? (items.request.student_id ?? null)
            : (items.student_id ?? null),
          birth_date: items.request
            ? (items.request.birth_date ?? null)
            : (items.birth_date ?? null),
          username: items.request
            ? (items.request.username ?? null)
            : (items.username ?? null),
          password: items.request
            ? (items.request.password ?? null)
            : (items.password ?? null),
          nickname_th: items.request
            ? (items.request.nickname_th ?? null)
            : (items.nickname_th ?? null),
          nickname_eng: items.request
            ? (items.request.nickname_eng ?? null)
            : (items.nickname_eng ?? null),
          department: items.request
            ? (items.request.department ?? null)
            : (items.department ?? null),
          mobile_on: items.request
            ? (items.request.mobile ?? null)
            : (items.mobile ?? null),
          response: items.response ? items.response : null,
          is_ca_fail: items.is_ca_fail ?? false,
        };
      }),
    );

    setMemberOneFail(
      details.importHistories[
        details.importHistories.length - 1
      ].failDetail.map((items, index) => {
        return items;
      }),
    );
    setMemberFail(
      details.importHistories[
        details.importHistories.length - 1
      ].failDetail.map((items, index) => {
        return items;
      }),
    );
    setMemberSuccess(
      details.importHistories[
        details.importHistories.length - 1
      ].successDetail.map((items, index) => {
        return items;
      }),
    );
    setFileID(details._id);
    setTotal(details.importHistories[details.importHistories.length - 1].total);
  };

  useEffect(() => {
    prepareData();
  }, [details]);

  const params = useParams();
  const navigate = useNavigate();

  // ข้อมูลเก่าที่ไม่มี request.key จะได้ idx-N ให้ตรงกับ key ของแถวในตาราง
  const withKey = (items, index) =>
    items?.request
      ? { ...items, request: { ...items.request, key: rowKey(items, index) } }
      : items;

  const handleRetry = async () => {
    const last = details.importHistories[details.importHistories.length - 1];
    const failKeyed = last.failDetail.map(withKey);
    const successResults = [];
    const failResults = [];
    const setRowLoading = (key, loadingValue) => {
      const index = failKeyed.findIndex((m) => m.request?.key === key);
      if (index !== -1)
        dispatch(
          setHistoryFailDataLoadingWithIndexRedux({
            loading: loadingValue,
            index,
          }),
        );
    };

    setLoading(true);
    try {
      await retryPreRegisterItems({
        keys: stateBtnAgain,
        memberOneFail: failKeyed.filter((m) => m.request),
        objective,
        objectiveCheck,
        business_id,
        file_id: fileID,
        services,
        onItemStart: (key) => setRowLoading(key, true),
        onItemSuccess: (key, result) => {
          successResults.push(result);
          setRowLoading(key, false);
        },
        onItemFail: (key, result) => {
          failResults.push(result);
          setRowLoading(key, false);
        },
      });

      const caFailResults = [];
      if (objective.includes("CA") || objective.includes("import-excel-rama")) {
        for (const result of successResults.filter((item) => !item.caRetry)) {
          if (!result.response?.data?.account_id) continue;

          try {
            await axios({
              method: "POST",
              url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/ca`,
              data: buildCAPayload(result, business_id),
            });
          } catch (error) {
            caFailResults.push({
              request: result.request,
              response: buildCAFailResponse(error),
              retryType: "ca",
              is_ca_fail: true,
              account_id: result.response.data.account_id,
              oneIdResponse: result.response,
            });
          }
        }
      }

      const caFailKeys = new Set(caFailResults.map((r) => r.request.key));
      const completedResults = successResults.filter((r) => !caFailKeys.has(r.request.key));
      const allFailResults = [...failResults, ...caFailResults];
      const okKeys = new Set(completedResults.map((r) => r.request.key));
      const failByKey = new Map(allFailResults.map((f) => [f.request.key, f]));
      const failDetail = failKeyed
        .filter((m) => !okKeys.has(m.request?.key))
        .map((m) => failByKey.get(m.request?.key) ?? m);
      const successDetail = [...(last.successDetail ?? []), ...completedResults];

      setDetails({
        ...details,
        importHistories: [
          ...details.importHistories.slice(0, -1),
          { ...last, failDetail, successDetail },
        ],
      });
      dispatch(setHistorySuccess({ historysuccess: successDetail.length }));
      dispatch(setHistoryFail({ historyfail: failDetail.length }));
      await sendExcelSummary(successDetail, failDetail);
      setStateBtnAgain([]);
    } finally {
      setLoading(false);
    }
  };

  const sendExcelSummary = async (success, fail) => {
    let obj = [...objective];
    if (objectiveCheck.includes("ra") && !objective.includes("one-id-ra")) {
      obj = [...objective, "one-id-ra"];
    }
    try {
      await axios({
        method: "PATCH",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
        data: {
          _id: fileID,
          total: (success.length + fail.length).toString(),
          success: `${success.length}`,
          fail: `${fail.length}`,
          successDetail: success,
          objective: obj,
          objectiveCheck: objectiveCheck,
          failDetail: fail,
        },
      });
      if (objective.includes("one-id-ra")) {
        await sendEmailRA();
      }
      // ไม่ต้อง setData ที่นี่: setDetails() ใน retryWith ทำให้ useEffect([details]) -> prepareData derive ตารางใหม่ให้
    } catch (error) {
      if (error.response?.status === 401) {
        navigate(`/${params.prefix}`);
      }
    }
  };

  const sendEmailRA = async () => {
    setLoading(true);
    try {
      await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/send-mail-oneid-ra?biz_id=${business_id}&file_id=${fileID}`,
      });
    } catch (error) {
      console.error(
        "Failed to send RA email:",
        error.response?.data ?? error.message,
      );
    } finally {
      setLoading(false);
    }
  };
  // end create again
  // function edit
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      index: "",
      contract_no: "",
      title_th: "",
      title_special_th: "",
      employee_id: "",
      name_th: "",
      surname_th: "",
      name_eng: "",
      surname_eng: "",
      cid: "",
      address: "",
      tel: "",
      mobile: "",
      email: "",
      biz_email: "",
      position: "",
      sub_organization: "",
      // organization:'',
      // tax_id:'',
      // maintainer_name_1:'',
      // maintainer_surname_1:'',
      // maintainer_name_2:'',
      // maintainer_surname_2:'',
      // maintainer_email_1:'',
      // maintainer_email_2:'',
      // maintainer_tel_1:'',
      // maintainer_tel_2:'',
      // age: '',
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key, not_set = false) => {
    setStateBtnAgain([]);
    try {
      // alert(0)
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => {
        return key === item.index;
      });
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setMemberFail(newData);
        setMemberOneFail(newData);
        setDetails({
          ...details,
          importHistories: [
            {
              ...details.importHistories[details.importHistories.length - 1],
              failDetail: details.importHistories[
                details.importHistories.length - 1
              ].failDetail.map((fail, loopIndex) => {
                let tempFail = { ...fail };
                if (loopIndex === index) {
                  tempFail.request = newData[index];
                }
                return tempFail;
              }),
            },
          ],
        });
        if (!not_set) {
          setEditingKey("");
        }
      } else {
        newData.push(row);
        setData(newData);
        if (!not_set) {
          setEditingKey("");
        }
      }
    } catch (errInfo) {}
  };

  const customLocale = {
    emptyText: <Empty description="ไม่มีข้อมูล" />,
  };

  const [stateBtnAgain, setStateBtnAgain] = useState([]);
  const rowSelection = {
    selectedRowKeys: stateBtnAgain,
    onChange: (selectedRowKeys, selectedRows) => {
      setStateBtnAgain(selectedRowKeys);
    },
    getCheckboxProps: (selectedRowKeys) => {
      return {
        // Column configuration not to be checked
        key: selectedRowKeys.key,
        disabled: loading,
      };
    },
  };

  const columns = [
    {
      title: "ลำดับที่",
      width: 150,
      editable: true,
      show: true,
      render: (_, __, index) => index + 1,
      // fixed: 'left',
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contract_no",
      width: 150,
      editable: true,
      show: objective.includes("เลขที่หนังสือสัญญา"),
      // fixed: 'left',
    },
    {
      title: "รหัสพนักงาน",
      dataIndex: "employee_id",
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes("one-id") || objectiveCheck.includes("ra"),
    },
    {
      title: "คำนำหน้า",
      dataIndex: "title_th",
      width: 150,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_th">คำนำหน้า</InputLabel>
            <Select
              value={record.title_th}
              labelId="title_th"
              label="คำนำหน้า"
              onChange={(e) => {
                // let tempData = [...data]
                // tempData[index].title_th = e.target.value
                // setData(tempData)

                const title_th_list = [
                  "นาย",
                  "นาง",
                  "นางสาว",
                  "เด็กหญิง",
                  "เด็กชาย",
                ];
                const title_en_list = ["Mr", "Mrs", "Miss", "Miss", "Master"];
                const title_en =
                  title_en_list[title_th_list.indexOf(e.target.value)];
                dispatch(
                  setHistoryFailDataTitleENWithIndexRedux({
                    index: index,
                    title_en: title_en,
                  }),
                );
                dispatch(
                  setHistoryFailDataTitleTHWithIndexRedux({
                    index: index,
                    title_th: e.target.value,
                  }),
                );
              }}
            >
              <MenuItem value={"นาย"}>นาย</MenuItem>
              <MenuItem value={"นางสาว"}>นางสาว</MenuItem>
              <MenuItem value={"นาง"}>นาง</MenuItem>
              {objective.includes("edu-student-pre-register") && (
                <MenuItem value={"เด็กชาย"}>เด็กชาย</MenuItem>
              )}
              {objective.includes("edu-student-pre-register") && (
                <MenuItem value={"เด็กหญิง"}>เด็กหญิง</MenuItem>
              )}
            </Select>
          </FormControl>
        ) : (
          record.title_th
        );
      },
    },
    {
      title: "คำนำหน้านาม",
      dataIndex: "title_special_th",
      width: 200,
      show: objective.includes("Pre-register"),
      // hidden: !objective.includes('Pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // width: '10%',
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_special_th">คำนำหน้านาม</InputLabel>
            <Select
              value={record.title_special_th}
              labelId="title_special_th"
              label="คำนำหน้านาม"
              onChange={(e) => {
                let tempData = [...data];
                tempData[index].title_special_th = e.target.value;
                setData(tempData);
              }}
            >
              <MenuItem value={"นายแพทย์"}>นายแพทย์</MenuItem>
              <MenuItem value={"แพทย์หญิง"}>แพทย์หญิง</MenuItem>
              <MenuItem value={"ทันตแพทย์ชาย"}>ทันตแพทย์ชาย</MenuItem>
              <MenuItem value={"ทันตแพทย์หญิง"}>ทันตแพทย์หญิง</MenuItem>
              <MenuItem value={"เภสัชกรหญิง"}>เภสัชกรหญิง</MenuItem>
              <MenuItem value={"เภสัชกรชาย"}>เภสัชกรชาย</MenuItem>
            </Select>
          </FormControl>
        ) : (
          record.title_special_th
        );
      },
    },
    {
      title: "คำนำหน้าอื่นๆ (ภาษาไทย)",
      dataIndex: "special_title_th",
      width: 180,
      editable: true,
      show:
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-teacher-pre-register") ||
        objective.includes("edu-officer-pre-register") ||
        services.includes("one-id") ||
        objectiveCheck.includes("ra") ||
        services.includes("one-id-pmuc"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "คำนำหน้า (ภาษาอังกฤษ)",
      dataIndex: "title_en",
      width: 150,
      show: true,
      // width: '10%',
      // editable: true,
      // ...getColumnSearchProps('title_th'),
      render: (_, record, index) => {
        let show = "";
        if (!_) {
          const title_th_list = ["นาย", "นาง", "นางสาว", "เด็กหญิง", "เด็กชาย"];
          const title_en_list = ["Mr", "Mrs", "Miss", "Miss", "Master"];
          const title_en =
            title_en_list[title_th_list.indexOf(record.title_th)];
          show = title_en;
        } else {
          show = _;
        }
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
            <Select
              value={show}
              labelId="title_en"
              label="ภาษาอังกฤษ"
              onChange={(e) => {
                const title_th_list = [
                  "นาย",
                  "นาง",
                  "นางสาว",
                  "เด็กหญิง",
                  "เด็กชาย",
                ];
                const title_en_list = ["Mr", "Mrs", "Miss", "Miss", "Master"];
                const title_th =
                  title_th_list[title_en_list.indexOf(e.target.value)];
                dispatch(
                  setHistoryFailDataTitleTHWithIndexRedux({
                    index: index,
                    title_th: title_th,
                  }),
                );
                dispatch(
                  setHistoryFailDataTitleENWithIndexRedux({
                    index: index,
                    title_en: e.target.value,
                  }),
                );
              }}
            >
              <MenuItem value={"Mr"}>Mr</MenuItem>
              <MenuItem value={"Miss"}>Miss</MenuItem>
              <MenuItem value={"Mrs"}>Mrs</MenuItem>
              {objective.includes("edu-student-pre-register") && (
                <MenuItem value={"Master"}>Master</MenuItem>
              )}
            </Select>
          </FormControl>
        ) : (
          show
        );
      },
    },
    {
      title: "คำนำหน้าอื่นๆ (ภาษาอังกฤษ)",
      dataIndex: "special_title_eng",
      width: 180,
      editable: true,
      show:
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-teacher-pre-register") ||
        objective.includes("edu-officer-pre-register") ||
        services.includes("one-id") ||
        objectiveCheck.includes("ra") ||
        services.includes("one-id-pmuc"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "เลขประจำตัวบุคลากรทางการแพทย์",
      dataIndex: "employee_id",
      width: 180,
      editable: true,
      show: objective.includes("Pre-register"),
      //   hidden: !objective.includes('Pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อ (ภาษาไทย)",
      dataIndex: "name_th",
      width: 150,
      editable: true,
      show: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อกลาง (ภาษาไทย)",
      dataIndex: "middle_name_th",
      width: 150,
      show:
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-officer-pre-register"),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: (
        <>
          นามสกุล <br />
          (ภาษาไทย)
        </>
      ),
      dataIndex: "surname_th",
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อ (ภาษาอังกฤษ)",
      dataIndex: "name_eng",
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อกลาง (ภาษาอังกฤษ)",
      dataIndex: "middle_name_eng",
      width: 150,
      show:
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-officer-pre-register"),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: (
        <>
          นามสกุล <br />
          (ภาษาอังกฤษ)
        </>
      ),
      dataIndex: "surname_eng",
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ฉายา (ภาษาไทย)",
      dataIndex: "nickname_th",
      width: 150,
      editable: true,
      show: objective.includes("edu-teacher-pre-register"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: "ฉายา (อังกฤษ)",
      dataIndex: "nickname_eng",
      width: 180,
      editable: true,
      show: objective.includes("edu-teacher-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "ประเภทบัตร",
      dataIndex: "id_card_type",
      width: 180,
      show:
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-teacher-pre-register") ||
        objective.includes("edu-officer-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
            <Select
              value={record.id_card_type}
              labelId="id_card_type"
              label="ประเภทบัตร"
              onChange={(e) => {
                let tempData = [...data];
                tempData[index].id_card_type = e.target.value;
                setData(tempData);
              }}
            >
              <MenuItem value={"ID_CARD"}>ID_CARD</MenuItem>
              <MenuItem value={"PASSPORT"}>PASSPORT</MenuItem>
              {objective.includes("edu-student-pre-register") && (
                <MenuItem value={"G_CODE"}>G_CODE</MenuItem>
              )}
            </Select>
          </FormControl>
        ) : (
          record.id_card_type
        );
      },
    },
    {
      title: "เลขประจำตัวประชาชน",
      dataIndex: "cid",
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ระดับการศึกษา",
      dataIndex: "degree",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "คณะ",
      dataIndex: "faculty",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "Major (สาขา/ภาควิชา)",
      dataIndex: "major",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "Minor (ถ้ามี)",
      dataIndex: "minor",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "สถานะการศึกษา",
      dataIndex: "status",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      width: 400,
      editable: true,
      show: objective.includes("import-excel-rama"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show:
        objective.includes("edu-teacher-pre-register") ||
        objective.includes("edu-student-pre-register"),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "บ้านเลขที่",
      dataIndex: "house_no",
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: "ห้องที่",
      dataIndex: "room_no",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "หมู่ที่",
      dataIndex: "moo",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "ชั้นที่",
      dataIndex: "floor",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "ถนน",
      dataIndex: "street",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "อาคาร",
      dataIndex: "building_name",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "หมู่บ้าน",
      dataIndex: "alley",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "ตำบล",
      dataIndex: "sub_district",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes("edu-teacher-pre-register"),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "อำเภอ",
      dataIndex: "district",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes("edu-teacher-pre-register"),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "จังหวัด",
      dataIndex: "province",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes("edu-teacher-pre-register"),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "รหัสไปรษณีย์",
      dataIndex: "zipcode",
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes("edu-teacher-pre-register"),
      // ...getColumnSearchProps('address'),
    },
    {
      title: "วันที่เริ่มการศึกษา",
      dataIndex: "start_year",
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: "วันที่จบการศึกษา",
      dataIndex: "end_year",
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: "โทรศัพท์",
      dataIndex: "tel",
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โทรศัพท์มือถือ",
      dataIndex: "mobile",
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมล",
      dataIndex: "email",
      width: 250,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมลองค์กร",
      dataIndex: "biz_email",
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes("one-id") || objectiveCheck.includes("ra"),
    },
    {
      title: "username",
      dataIndex: "username",
      width: 180,
      editable: true,
      show: services.includes("one-id") || objectiveCheck.includes("ra"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "รหัสนักศึกษา",
      dataIndex: "student_id",
      width: 180,
      editable: true,
      show: objective.includes("edu-student-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "วันเกิด (ปปปป-ดด-วว)",
      dataIndex: "birth_date",
      width: 180,
      editable: true,
      show:
        objective.includes("edu-officer-pre-register") ||
        objective.includes("edu-student-pre-register") ||
        objective.includes("edu-teacher-pre-register") ||
        objective.includes("Pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
      render: (_) => {
        return <>{_}</>;
      },
    },
    {
      title: "username",
      dataIndex: "username",
      width: 180,
      editable: true,
      show: objective.includes("edu-teacher-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "password",
      dataIndex: "password",
      width: 180,
      editable: true,
      show: objective.includes("edu-teacher-pre-register"),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

      // ...getColumnSearchProps('name_th'),
    },
    {
      title: "ตำแหน่งของเจ้าของใบรับรอง",
      dataIndex: "position",
      width: 150,
      editable: true,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ตำแหน่ง",
      dataIndex: "position",
      width: 150,
      editable: true,
      show: objective.includes("Pre-register"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด",
      dataIndex: "sub_organization",
      width: 250,
      editable: true,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อองค์กรที่เจ้าของใบรับรองสังกัด",
      dataIndex: "organization",
      width: 350,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โรงพยาบาลที่สังกัด",
      dataIndex: "organization",
      width: 350,
      show: objective.includes("Pre-register"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล",
      dataIndex: "tax_id",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_name_1",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "นามสกุลคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_surname_1",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_name_2",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "นามสกุลคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_surname_2",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_name_3",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "นามสกุลคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_surname_3",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ชื่อคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_name_4",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_surname_4",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมล 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_email_1",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมล 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_email_2",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมล 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_email_3",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "อีเมล 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_email_4",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },

    {
      title: "โทรศัพท์มือถือ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_tel_1",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โทรศัพท์มือถือ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_tel_2",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โทรศัพท์มือถือ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_tel_3",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โทรศัพท์มือถือ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)",
      dataIndex: "maintainer_tel_4",
      width: 200,
      show:
        (objective.includes("CA") || objective.includes("import-excel-rama")) &&
        (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "โทรศัพท์มือถือ",
      dataIndex: "mobile_on",
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "แผนก",
      dataIndex: "department",
      width: 120,
      editable: true,
      show: services.includes("one-id-ra"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "ตำแหน่ง",
      dataIndex: "position",
      width: 120,
      editable: true,
      show: services.includes("one-id-ra"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: "operation",
      dataIndex: "operation",
      width: 200,
      show: true,
      fixed: "right",
      render: (_, record, index) => {
        const editable = isEditing(record);
        return record.loading ? (
          <LoadingComponent width={80} height={80} />
        ) : editable ? (
          <span>
            <Button
              type="primary"
              disabled={loading}
              onClick={() => save(record.index)}
              style={{
                marginRight: 8,
                background: "#53BE35",
              }}
            >
              บันทึก
            </Button>
            <Popconfirm
              title="Sure to cancel?"
              disabled={loading}
              onConfirm={cancel}
            >
              ยกเลิก
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link
              disabled={editingKey !== "" || loading}
              onClick={() => edit(record)}
            >
              <ModeEditOutlinedIcon
                style={{ color: "#053075" ?? style.primary_color }}
              />
            </Typography.Link>{" "}
            &nbsp; &nbsp;
            <Button
              size="large"
              disabled={loading}
              style={{ backgroundColor: "#F8F9FA", color: "#053075" }}
              onClick={() => {
                const notes = [].concat(resolveNoteText(record.response?.message));
                setNoteTXT(record.is_ca_fail ? [CA_FAILURE_MESSAGE, ...notes] : notes);
                setModalNote(true);
              }}
            >
              หมายเหตุ
            </Button>
          </>
        );
      },
    },
  ].filter((head) => head.show);
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        // inputType: col.dataIndex === 'age' ? 'number' : 'text',
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <>
      <Row>
        <Col className="d-flex justify-content-end">
          {stateBtnAgain.length !== 0 ? (
            <Button
              type="primary"
              style={{
                background: style.secondary_color ?? "#053075",
                color: style.secondary_color
                  ? fontColor(style.secondary_color)
                  : "#FFFFFF",
              }}
              disabled={loading}
              onClick={handleRetry}
            >
              <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
            </Button>
          ) : null}
        </Col>
      </Row>
      <Row style={{ marginTop: "20px" }}>
        {/* ui table */}
        <Form form={form} component={false}>
          <Table
            locale={customLocale}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={{
              onChange: cancel,
            }}
            scroll={{
              x: 1400,
              y: 400,
            }}
            rowSelection={{
              type: "checkbox",
              ...rowSelection,
            }}
          />
        </Form>
        {/* end ui table */}
        {/* modal หมายเหตุ */}
        <Modal
          title="หมายเหตุ"
          centered
          open={modalNote}
          footer={null}
          onCancel={() => setModalNote(false)}
        >
          <ul>
            {noteTXT
              .flat(Infinity)
              .filter(Boolean)
              .map((n, i) => (
                <li key={i}>{typeof n === "string" ? n : JSON.stringify(n)}</li>
              ))}
          </ul>
        </Modal>
        {/* end modal หมายเหตุ */}
      </Row>
    </>
  );
};
export default HistoryDetailFail